function fnv1aWord(value: string, seed: number): number {
  let hash = seed >>> 0;
  for (let i = 0; i < value.length; i++) {
    hash ^= value.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193) >>> 0;
  }
  return hash >>> 0;
}

const toHex8 = (n: number) => n.toString(16).padStart(8, '0');

/**
 * Deterministic, non-cryptographic string → GUID string (FNV-1a over 4 seeds, formatted
 * as the standard 8-4-4-4-12 hex groups). Not a real UUID — for preference rows that aren't
 * backed by real CMS content nodes, where the backend accepts any well-formed Guid and
 * performs no CMS existence check, but the same input must always produce the same Guid
 * so toggling on/off and "is selected" checks stay consistent.
 */
export function syntheticGuid(value: string): string {
  const a = toHex8(fnv1aWord(value, 0x811c9dc5));
  const b = toHex8(fnv1aWord(value, 0x9e3779b9));
  const c = toHex8(fnv1aWord(value, 0x85ebca6b));
  const d = toHex8(fnv1aWord(value, 0xc2b2ae35));
  return `${a}-${b.slice(0, 4)}-${b.slice(4, 8)}-${c.slice(0, 4)}-${c.slice(4, 8)}${d.slice(0, 8)}`;
}
